import type { OrganizationVerificationRequest } from "../../client";
import { createEntityAdapter } from "@reduxjs/toolkit";

export const verificationRequestEntityAdapter = createEntityAdapter<OrganizationVerificationRequest>({
});